/**
 * 插件状态
 */
export var PluginState;
(function (PluginState) {
    /**
     * 未安装
     */
    PluginState["NotInstalled"] = "not_installed";
    /**
     * 已安装
     */
    PluginState["Installed"] = "installed";
    /**
     * 安装失败
     */
    PluginState["Failed"] = "failed";
})(PluginState || (PluginState = {}));
//# sourceMappingURL=Plugin.js.map